document.addEventListener("DOMContentLoaded", async () => {

  // ================================
  // NORMALISE SCHOOL ID
  // ================================
  if (window.teacher && window.teacher.schoolId) {
    window.teacher.schoolId =
      window.teacher.schoolId
        .toString()
        .trim()
        .padStart(10, "0");
  }

  const t = window.teacher || {};

  const classSection =
    document.getElementById("classSection");

  const classSelect =
    document.getElementById("classSelect");

  const learnerList =
    document.getElementById("learnerList");

  const validateBtn =
    document.getElementById("validateTotals");

  const submitBtn =
    document.getElementById("submitAttendance");

  const messageBox =
    document.getElementById("adminMessage");

  const reasonSelect =
    document.getElementById("reasonSelect");

  const absentToggle =
    document.getElementById("absentToggle");

  const dateInput =
    document.getElementById("attendanceDate");

  const boysPresentInput =
    document.getElementById("boysPresentTotal");

  const boysAbsentInput =
    document.getElementById("boysAbsentTotal");

  const girlsPresentInput =
    document.getElementById("girlsPresentTotal");

  const girlsAbsentInput =
    document.getElementById("girlsAbsentTotal");

  let learnersData = [];
  let currentClassId = null;
  let validationAttempts = 0;
  let adminTeachers = [];

  let validDates = [];
  let validDatesLoaded = false;

  // Keep these disabled until Azure valid dates load successfully.
  validateBtn.disabled = true;
  submitBtn.disabled = true;

  // ================================
  // SPINNER
  // ================================
  const spinner =
    document.createElement("div");

  spinner.id = "caraSpinner";
  spinner.style.display = "none";
  spinner.style.textAlign = "center";
  spinner.style.marginTop = "20px";

  spinner.innerHTML = `
    <div style="display:flex; flex-direction:column; align-items:center;">
      <div style="
        border: 4px solid #e0e0e0;
        border-top: 4px solid #217346;
        border-radius: 50%;
        width: 40px;
        height: 40px;
        animation: spin 1s linear infinite;
      "></div>
      <p style="color:#217346; margin-top:10px; font-size:16px;">
        Submitting attendance…
      </p>
      <p style="color:#888; font-size:13px; margin-top:4px;">
        Cara powered by <strong>iForm365</strong>
      </p>
    </div>
  `;

  const attendanceWrapper =
    document.querySelector(".attendance-wrapper");

  if (attendanceWrapper) {
    attendanceWrapper.appendChild(spinner);
  }

  const style =
    document.createElement("style");

  style.innerHTML =
    "@keyframes spin {" +
    "0% { transform: rotate(0deg); }" +
    "100% { transform: rotate(360deg); }" +
    "}";

  document.head.appendChild(style);

  // ================================
  // DATE NORMALISATION
  // ================================
  function normalizeDateOnly(value) {
    if (value === null || value === undefined) {
      return null;
    }

    const text =
      String(value).trim();

    const match =
      text.match(
        /^(\d{4})[-/](\d{1,2})[-/](\d{1,2})$/
      );

    if (!match) {
      return null;
    }

    const year = match[1];
    const month = match[2].padStart(2, "0");
    const day = match[3].padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  function getSelectedValidDateIso() {
    if (!validDatesLoaded) {
      return null;
    }

    const isoDate =
      normalizeDateOnly(dateInput.value);

    if (!isoDate) {
      return null;
    }

    if (!validDates.includes(isoDate)) {
      return null;
    }

    return isoDate;
  }

  // ================================
  // RESET SUBMIT STATE
  // ================================
  function resetSubmitState() {
    const canUseForm =
      Boolean(t.isLoggedIn) &&
      validDatesLoaded;

    validateBtn.disabled = !canUseForm;
    submitBtn.disabled = !canUseForm;

    submitBtn.textContent =
      "Submit Attendance";

    submitBtn.removeAttribute("style");

    const existing =
      document.querySelector(
        ".attendance-wrapper .confirmation-box"
      );

    if (existing) {
      existing.remove();
    }
  }

  // ================================
  // ROLE + CLASS UI INITIALIZATION
  // ================================
  function initRoleAndClassUI() {
    if (!t.isLoggedIn) {
      messageBox.value =
        "You must be logged in to capture attendance.";

      submitBtn.disabled = true;
      validateBtn.disabled = true;
      return;
    }

    const role =
      (t.role || "teacher").toLowerCase();

    if (role === "teacher") {
      currentClassId =
        (t.classId || "").trim();

      classSection.style.display =
        "none";
    } else {
      classSection.style.display =
        "block";

      const label =
        classSection.querySelector("h2");

      if (label) {
        label.textContent =
          "Select Absent Teacher's Class";
      }
    }
  }

  // ================================
  // LOAD VALID DATES FROM AZURE
  // ================================
  async function loadValidDates() {
    validDatesLoaded = false;
    validDates = [];

    try {
      if (
        !window.azure ||
        !window.azure.getValidDatesKey ||
        !t.schoolId
      ) {
        messageBox.value =
          "Valid school dates could not be loaded.";

        submitBtn.disabled = true;
        validateBtn.disabled = true;
        return;
      }

      const url =
        "https://attendance-backend-e4cbgrcxc5czd3ez." +
        "southafricanorth-01.azurewebsites.net/api/getValidDates" +
        `?schoolId=${encodeURIComponent(t.schoolId)}` +
        `&code=${encodeURIComponent(
          window.azure.getValidDatesKey
        )}`;

      const res =
        await fetch(url);

      if (!res.ok) {
        messageBox.value =
          "Valid school dates could not be loaded. " +
          "Attendance is unavailable.";

        submitBtn.disabled = true;
        validateBtn.disabled = true;

        console.warn(
          "getValidDates failed:",
          res.status
        );

        return;
      }

      const data =
        await res.json();

      validDates =
        (
          Array.isArray(data.dates)
            ? data.dates
            : []
        )
          .map(normalizeDateOnly)
          .filter(Boolean);

      if (validDates.length === 0) {
        messageBox.value =
          "No valid school dates were returned. " +
          "Attendance is unavailable.";

        submitBtn.disabled = true;
        validateBtn.disabled = true;
        return;
      }

      validDatesLoaded = true;

      submitBtn.disabled = false;
      validateBtn.disabled = false;

      applyDateRestrictions();

    } catch (err) {
      validDatesLoaded = false;
      validDates = [];

      submitBtn.disabled = true;
      validateBtn.disabled = true;

      messageBox.value =
        "Valid school dates could not be loaded. " +
        "Attendance is unavailable.";

      console.warn(
        "loadValidDates error:",
        err.message || err
      );
    }
  }

  // ================================
  // APPLY DATE RESTRICTIONS
  // ================================
  function applyDateRestrictions() {
    if (!validDatesLoaded) {
      return;
    }

    const sortedDates =
      [...validDates].sort();

    dateInput.min =
      sortedDates[0];

    dateInput.max =
      sortedDates[sortedDates.length - 1];

    dateInput.addEventListener("change", () => {
      const selectedDateIso =
        getSelectedValidDateIso();

      if (!selectedDateIso) {
        messageBox.value =
          `⚠️ ${dateInput.value} is not a valid school day. ` +
          "Please select a valid date.";

        dateInput.value = "";
      }
    });
  }

  // ================================
  // LOAD DATA BY ROLE
  // ================================
  async function loadData() {
    if (!validDatesLoaded) {
      messageBox.value =
        "Valid school dates are not available.";
      return;
    }

    if (
      !window.azure ||
      !window.azure.learnersKey
    ) {
      messageBox.value =
        "Configuration error: Azure keys not loaded.";
      return;
    }

    if (!t.schoolId) {
      messageBox.value =
        "Configuration error: School ID not available.";
      return;
    }

    const role =
      (t.role || "teacher").toLowerCase();

    if (role !== "teacher") {
      await loadAdminTeachers();

      messageBox.value =
        "Select an absent teacher's class to load learners.";

      return;
    }

    if (!currentClassId) {
      messageBox.value =
        "Configuration error: Class ID not assigned.";
      return;
    }

    if (!dateInput.value) {
      messageBox.value =
        `Please select a date to load class ${currentClassId}.`;

      return;
    }

    await fetchLearnersForClass(currentClassId);
  }

  // ================================
  // LOAD CLASSES FOR ADMIN
  // ================================
  async function loadAdminTeachers() {
    try {
      const classUrl =
        "https://attendance-backend-e4cbgrcxc5czd3ez." +
        "southafricanorth-01.azurewebsites.net/api/classes" +
        `?schoolId=${encodeURIComponent(t.schoolId)}` +
        `&code=${encodeURIComponent(
          window.azure.classesKey
        )}`;

      const classRes =
        await fetch(classUrl);

      if (!classRes.ok) {
        messageBox.value =
          `Failed to load classes (${classRes.status}).`;

        return;
      }

      const classData =
        await classRes.json();

      const classes =
        (classData.classes || [])
          .filter(Boolean)
          .sort();

      classSelect.innerHTML =
        '<option value="">-- Choose a class --</option>';

      classes.forEach(cls => {
        const opt =
          document.createElement("option");

        opt.value = cls;
        opt.textContent = cls;

        classSelect.appendChild(opt);
      });

      if (classes.length === 0) {
        messageBox.value =
          "No classes found for this school.";

        return;
      }

      const learnersUrl =
        "https://attendance-backend-e4cbgrcxc5czd3ez." +
        "southafricanorth-01.azurewebsites.net/api/learners" +
        `?schoolId=${encodeURIComponent(t.schoolId)}` +
        `&code=${encodeURIComponent(
          window.azure.learnersKey
        )}`;

      const learnersRes =
        await fetch(learnersUrl);

      if (learnersRes.ok) {
        const learnersJson =
          await learnersRes.json();

        learnersData =
          learnersJson.learners ||
          learnersJson ||
          [];
      }

    } catch (err) {
      messageBox.value =
        "Could not load classes: " +
        (err.message || err);
    }
  }

  // ================================
  // FETCH LEARNERS FOR CLASS
  // ================================
  async function fetchLearnersForClass(classId) {
    if (!classId) {
      return;
    }

    classId =
      classId.toUpperCase();

    // --------------------------------
    // Step 1: Flag check
    // --------------------------------
    try {
      const flagUrl =
        "https://attendance-backend-e4cbgrcxc5czd3ez." +
        "southafricanorth-01.azurewebsites.net/api/learners" +
        `?schoolId=${encodeURIComponent(t.schoolId)}` +
        `&classId=${encodeURIComponent(classId)}` +
        `&code=${encodeURIComponent(
          window.azure.learnersKey
        )}`;

      const flagRes =
        await fetch(flagUrl);

      if (!flagRes.ok) {
        messageBox.value =
          `Azure error ${flagRes.status}: ` +
          `${await flagRes.text()}`;

        return;
      }

      const flagData =
        await flagRes.json();

      if (flagData.status === "FLAGGED") {
        setListLocked(true);

        submitBtn.disabled = true;
        validateBtn.disabled = true;

        messageBox.value =
          `🚫 Class ${classId} is flagged. ` +
          "Attendance cannot be submitted.\n" +
          "Please contact your school administrator " +
          "to have the flag lifted.";

        Array.from(
          classSelect.options
        ).forEach(opt => {
          if (
            opt.value === classId &&
            !opt.textContent.includes("[FLAGGED]")
          ) {
            opt.disabled = true;
            opt.textContent += " [FLAGGED]";
          }
        });

        return;
      }

    } catch (err) {
      messageBox.value =
        "Could not check class status: " +
        (err.message || err);

      return;
    }

    // --------------------------------
    // Step 2: Valid date check
    // --------------------------------
    const selectedDateIso =
      getSelectedValidDateIso();

    if (!selectedDateIso) {
      messageBox.value =
        "⚠️ Please select a valid school day " +
        "before loading the class.";

      return;
    }

    // --------------------------------
    // Step 3: Date-aware roster
    // --------------------------------
    try {
     const dateFmt =
  selectedDateIso.replace(/-/g, "/");



      const rosterUrl =
        "https://attendance-backend-e4cbgrcxc5czd3ez." +
        "southafricanorth-01.azurewebsites.net/api/getClassRoster" +
        `?schoolId=${encodeURIComponent(t.schoolId)}` +
        `&classId=${encodeURIComponent(classId)}` +
        `&date=${encodeURIComponent(dateFmt)}` +
        `&code=${encodeURIComponent(
          window.azure.getClassRosterKey
        )}`;

      const rosterRes =
        await fetch(rosterUrl);

      if (!rosterRes.ok) {
        console.warn(
          "getClassRoster fallback to Names.csv:",
          rosterRes.status
        );

        const fallbackUrl =
          "https://attendance-backend-e4cbgrcxc5czd3ez." +
          "southafricanorth-01.azurewebsites.net/api/learners" +
          `?schoolId=${encodeURIComponent(t.schoolId)}` +
          `&classId=${encodeURIComponent(classId)}` +
          `&code=${encodeURIComponent(
            window.azure.learnersKey
          )}`;

        const fallbackRes =
          await fetch(fallbackUrl);

        if (!fallbackRes.ok) {
          throw new Error(
            `Learner fallback failed (${fallbackRes.status})`
          );
        }

        const fallback =
          await fallbackRes.json();

        learnersData =
          (fallback.learners || [])
            .map(l => ({
              cemisNo:
                l.LearnerCemis ||
                l.cemisNo ||
                "",

              learnerName:
                l.Name ||
                l.learnerName ||
                "",

              gender:
                (
                  l.Gender ||
                  l.gender ||
                  ""
                ).trim(),

              dob:
                l.DOB ||
                l.dob ||
                "",

              class:
                l.Class ||
                l.class ||
                classId
            }));

        window._rosterTotals = null;

      } else {
        const rosterData =
          await rosterRes.json();

        window._rosterTotals = {
          boys:
            rosterData.boysCount ?? null,

          girls:
            rosterData.girlsCount ?? null,

          total:
            rosterData.totalCount ?? null
        };

        learnersData =
          (rosterData.learners || [])
            .map(l => ({
              cemisNo:
                l.cemisNo ||
                l.LearnerCemis ||
                "",

              learnerName:
                l.learnerName ||
                l.Name ||
                "",

              gender:
                (
                  l.gender ||
                  l.Gender ||
                  ""
                ).trim(),

              dob:
                l.dob ||
                l.DOB ||
                "",

              class:
                l.class ||
                l.Class ||
                classId
            }));
      }

      populateLearnersForClass(classId);

    } catch (err) {
      messageBox.value =
        "Could not load learner list: " +
        (err.message || err);
    }
  }

  // ================================
  // LOCK / UNLOCK LIST
  // ================================
  function setListLocked(locked) {
    learnerList.dataset.locked =
      locked ? "true" : "false";

    learnerList
      .querySelectorAll(".learner-row")
      .forEach(row => {
        row.style.pointerEvents =
          locked ? "none" : "auto";

        row.style.opacity =
          locked ? "0.01" : "1";

        row.style.color =
          locked ? "#aaa" : "#000";

        row.style.userSelect =
          locked ? "none" : "auto";
      });
  }

  function isListLocked() {
    return learnerList.dataset.locked !== "false";
  }

  // ================================
  // REASON OPTIONS
  // ================================
  function reasonOptionsHTML(
    selectedValue = ""
  ) {
    const options = [
      ["", "-- reason --"],
      [
        "Study Leave (With Notification)",
        "Approved Grade 12 exam preparation."
      ],
      [
        "Bereavement (No Notification)",
        "Bereavement (No Notification)"
      ],
      [
        "Bereavement (With Notification)",
        "Bereavement (With Notification)"
      ],
      [
        "Community Unrest (No Notification)",
        "Community Unrest (No Notification)"
      ],
      [
        "Community Unrest (With Notification)",
        "Community Unrest (With Notification)"
      ],
      [
        "Emergency/Weather (No Notification)",
        "Emergency/Weather (No Notification)"
      ],
      [
        "Emergency/Weather (With Notification)",
        "Emergency/Weather (With Notification)"
      ],
      [
        "Illness (No Notification)",
        "Illness (No Notification)"
      ],
      [
        "Illness (With Notification)",
        "Illness (With Notification)"
      ],
      [
        "Maternity (With Notification)",
        "Maternity (Official Notification)"
      ],
      [
        "Medical Appointment (No Notification)",
        "Medical Appointment (No Notification)"
      ],
      [
        "Medical Appointment (With Notification)",
        "Medical Appointment (With Notification)"
      ],
      [
        "Religious/Cultural (No Notification)",
        "Religious/Cultural (No Notification)"
      ],
      [
        "Religious/Cultural (With Notification)",
        "Religious/Cultural (With Notification)"
      ],
      [
        "School Suspension (Official)",
        "School Suspension (Official)"
      ],
      [
        "Truancy (No Notification)",
        "Truancy (No Notification)"
      ]
    ];

    return options
      .map(([val, label]) =>
        `<option value="${val}"` +
        `${val === selectedValue ? " selected" : ""}>` +
        `${label}</option>`
      )
      .join("");
  }

  // ================================
  // POPULATE LEARNERS
  // ================================
  function populateLearnersForClass(classId) {
    learnerList.innerHTML = "";

    if (!classId) {
      return;
    }

    learnersData.forEach(learner => {
      const row =
        document.createElement("div");

      row.className = "learner-row";

      row.dataset.id =
        learner.cemisNo || "";

      row.dataset.name =
        learner.learnerName || "";

      row.dataset.gender =
        learner.gender || "";

      row.dataset.classId =
        learner.class || classId;

      row.dataset.schoolId =
        t.schoolId || "";

      row.dataset.dob =
        learner.dob || "";

      row.dataset.status =
        "Present";

      row.dataset.reason =
        "N/A";

      row.style.cssText =
        "display:flex;" +
        "border-bottom:1px solid #d0e8d8;" +
        "cursor:pointer;" +
        "pointer-events:none;" +
        "opacity:0.01;" +
        "user-select:none;";

      row.innerHTML = `
        <div style="
          width:32px;
          padding:4px 6px;
          flex-shrink:0;
          display:flex;
          align-items:center;
        ">
          <input type="checkbox" class="learner-check">
        </div>

        <div style="
          flex:2;
          padding:4px 8px;
          align-self:center;
          font-size:0.9em;
        ">
          ${learner.cemisNo || ""} |
          ${learner.learnerName || ""}
        </div>

        <div style="
          flex:3;
          padding:2px 4px;
        ">
          <select
            class="row-reason"
            style="
              width:100%;
              border:1px solid #217346;
              padding:2px;
              font-size:0.82em;
            "
          >
            ${reasonOptionsHTML()}
          </select>
        </div>
      `;

      row.addEventListener("click", event => {
        if (isListLocked()) {
          return;
        }

        if (
          event.target.closest("select") ||
          event.target.matches(
            "input[type='checkbox']"
          )
        ) {
          return;
        }

        const checkbox =
          row.querySelector(".learner-check");

        checkbox.checked =
          !checkbox.checked;

        syncRowHighlight(
          row,
          checkbox.checked
        );

        if (!checkbox.checked) {
          row.dataset.status =
            "Present";

          row.dataset.reason =
            "N/A";
        }
      });

      row
        .querySelector(".learner-check")
        .addEventListener("change", event => {
          syncRowHighlight(
            row,
            event.target.checked
          );

          if (!event.target.checked) {
            row.dataset.status =
              "Present";

            row.dataset.reason =
              "N/A";
          }
        });

      row
        .querySelector(".row-reason")
        .addEventListener("change", event => {
          event.stopPropagation();

          const checkbox =
            row.querySelector(".learner-check");

          if (event.target.value) {
            checkbox.checked = true;

            syncRowHighlight(row, true);

            row.dataset.status =
              "Absent";

            row.dataset.reason =
              event.target.value;
          } else {
            row.dataset.status =
              "Present";

            row.dataset.reason =
              "N/A";
          }
        });

      learnerList.appendChild(row);
    });

    setListLocked(true);

    messageBox.value =
      `Class ${classId} loaded. ` +
      "Enter totals and validate.";
  }

  function syncRowHighlight(row, isSelected) {
    row.style.backgroundColor =
      isSelected ? "#d0e8d8" : "";

    row.classList.toggle(
      "selected",
      isSelected
    );
  }

  // ================================
  // CLASS SELECT CHANGE
  // ================================
  classSelect.addEventListener(
    "change",
    async () => {
      currentClassId =
        (classSelect.value || "")
          .toUpperCase() || null;

      learnerList.innerHTML = "";

      boysPresentInput.value = "";
      boysAbsentInput.value = "";
      girlsPresentInput.value = "";
      girlsAbsentInput.value = "";

      messageBox.value = "";

      resetSubmitState();

      if (currentClassId) {
        await fetchLearnersForClass(
          currentClassId
        );
      }
    }
  );

  // ================================
  // DATE CHANGE
  // ================================
  dateInput.addEventListener(
    "change",
    async () => {
      const selectedDateIso =
        getSelectedValidDateIso();

      if (!selectedDateIso) {
        learnerList.innerHTML = "";
        messageBox.value =
          "Please select a valid school day.";
        return;
      }

      if (currentClassId) {
        learnerList.innerHTML = "";

        boysPresentInput.value = "";
        boysAbsentInput.value = "";
        girlsPresentInput.value = "";
        girlsAbsentInput.value = "";

        messageBox.value = "";

        resetSubmitState();

        await fetchLearnersForClass(
          currentClassId
        );
      }
    }
  );

  // ================================
  // ABSENT TOGGLE + GLOBAL REASON
  // ================================
  function applyStatusAndReasonToSelection() {
    const isAbsent =
      absentToggle.checked;

    const globalReason =
      reasonSelect.value;

    learnerList
      .querySelectorAll(".learner-row")
      .forEach(row => {
        const checkbox =
          row.querySelector(".learner-check");

        if (!checkbox || !checkbox.checked) {
          return;
        }

        row.dataset.status =
          isAbsent ? "Absent" : "Present";

        if (isAbsent) {
          const rowReason =
            row.querySelector(
              ".row-reason"
            ).value;

          row.dataset.reason =
            rowReason ||
            globalReason ||
            "No notification";
        } else {
          row.dataset.reason =
            "N/A";
        }
      });
  }

  absentToggle.addEventListener(
    "change",
    applyStatusAndReasonToSelection
  );

  reasonSelect.addEventListener(
    "change",
    applyStatusAndReasonToSelection
  );

  // ================================
  // VALIDATE TOTALS
  // ================================
  validateBtn.addEventListener(
    "click",
    async () => {
      const rows =
        learnerList.querySelectorAll(
          ".learner-row"
        );

      let boysCount;
      let girlsCount;

      if (
        window._rosterTotals &&
        window._rosterTotals.boys !== null
      ) {
        boysCount =
          Number(window._rosterTotals.boys);

        girlsCount =
          Number(window._rosterTotals.girls);
      } else {
        boysCount = 0;
        girlsCount = 0;

        rows.forEach(row => {
          const gender =
            (row.dataset.gender || "")
              .trim()
              .toUpperCase();

          if (gender.startsWith("M")) {
            boysCount++;
          } else if (
            gender.startsWith("F")
          ) {
            girlsCount++;
          }
        });
      }

      const totalLearners =
        boysCount + girlsCount;

      const boysPresent =
        parseInt(
          boysPresentInput.value,
          10
        ) || 0;

      const boysAbsent =
        parseInt(
          boysAbsentInput.value,
          10
        ) || 0;

      const girlsPresent =
        parseInt(
          girlsPresentInput.value,
          10
        ) || 0;

      const girlsAbsent =
        parseInt(
          girlsAbsentInput.value,
          10
        ) || 0;

      const boysTotal =
        boysPresent + boysAbsent;

      const girlsTotal =
        girlsPresent + girlsAbsent;

      const grandTotal =
        boysTotal + girlsTotal;

      const errors = [];

      if (boysTotal !== boysCount) {
        errors.push(
          "Boys total does not match."
        );
      }

      if (girlsTotal !== girlsCount) {
        errors.push(
          "Girls total does not match."
        );
      }

      if (grandTotal !== totalLearners) {
        errors.push(
          "Grand total does not match."
        );
      }

      if (errors.length === 0) {
        validationAttempts = 0;

        setListLocked(false);

        messageBox.value =
          `✅ Totals validated.\n` +
          `Boys: ${boysCount} ` +
          `(Present: ${boysPresent}, ` +
          `Absent: ${boysAbsent})\n` +
          `Girls: ${girlsCount} ` +
          `(Present: ${girlsPresent}, ` +
          `Absent: ${girlsAbsent})\n` +
          `Total: ${totalLearners}`;

        return;
      }

      validationAttempts++;
      setListLocked(true);

      if (validationAttempts === 1) {
        messageBox.value =
          "⚠️ Totals do not match. " +
          "Please recheck your rollcall and " +
          "validate again.\n" +
          errors.join("\n");

        return;
      }

      validationAttempts = 0;

      validateBtn.disabled = true;
      submitBtn.disabled = true;

      boysPresentInput.value = "";
      boysAbsentInput.value = "";
      girlsPresentInput.value = "";
      girlsAbsentInput.value = "";

      const flaggedClass =
        currentClassId;

      currentClassId = null;
      classSelect.value = "";

      messageBox.value =
        `🚫 Class ${flaggedClass} has been flagged ` +
        "due to repeated total discrepancies.\n" +
        "Attendance cannot be submitted for this class.\n" +
        "Please contact your school administrator " +
        "to have the flag lifted.";

      try {
        const flagUrl =
          "https://attendance-backend-e4cbgrcxc5czd3ez." +
          "southafricanorth-01.azurewebsites.net/api/tempflag" +
          `?code=${encodeURIComponent(
            window.azure.tempflagKey
          )}`;

        const flagRes =
          await fetch(flagUrl, {
            method: "POST",
            headers: {
              "Content-Type":
                "application/json"
            },
            body: JSON.stringify({
              schoolId: t.schoolId,
              classId: flaggedClass
            })
          });

        if (
          flagRes.ok
        ) {
          console.log(
            `Class ${flaggedClass} ` +
            "temp-flagged successfully."
          );
        } else {
          console.warn(
            "tempflag failed:",
            flagRes.status
          );
        }

      } catch (err) {
        console.warn(
          "tempflag write failed:",
          err.message || err
        );
      }

      Array.from(
        classSelect.options
      ).forEach(opt => {
        if (opt.value === flaggedClass) {
          opt.disabled = true;
          opt.textContent +=
            " [FLAGGED]";
        }
      });
    }
  );

  // ================================
  // TERM CALCULATION
  // ================================
  function getTermFromDate(dateStr) {
    const isoDate =
      normalizeDateOnly(dateStr);

    if (!isoDate) {
      return null;
    }

    const month =
      Number(isoDate.slice(5, 7));

    if (month <= 3) return 1;
    if (month <= 6) return 2;
    if (month <= 9) return 3;

    return 4;
  }

  // ================================
  // SUBMIT ATTENDANCE
  // ================================
  if (
    !window.azure ||
    !window.azure.attendanceKey
  ) {
    messageBox.value =
      "Configuration error: Attendance key not loaded.";
    return;
  }

  submitBtn.addEventListener(
    "click",
    async () => {
      if (!t.isLoggedIn) {
        messageBox.value =
          "Error: You are not logged in.";
        return;
      }

      if (
        !t.schoolId ||
        t.schoolId.toString().trim() === ""
      ) {
        messageBox.value =
          "Error: School ID (EMIS) is not set " +
          "on your account. Contact your administrator.";
        return;
      }

      if (
        !currentClassId ||
        currentClassId.trim() === ""
      ) {
        messageBox.value =
          "Error: No class assigned or selected.";
        return;
      }

      if (isListLocked()) {
        messageBox.value =
          "Validation not passed.";
        return;
      }

      const selectedDateIso =
        getSelectedValidDateIso();

      if (!selectedDateIso) {
        messageBox.value =
          "Please select a valid school day.";
        return;
      }

      const attendanceDate =
  selectedDateIso;



      // --------------------------------
      // Sync checked totals with marking
      // --------------------------------
      const allRows =
        Array.from(
          learnerList.querySelectorAll(
            ".learner-row"
          )
        );

      let actualBoysPresent = 0;
      let actualBoysAbsent = 0;
      let actualGirlsPresent = 0;
      let actualGirlsAbsent = 0;

      allRows.forEach(row => {
        const gender =
          (row.dataset.gender || "")
            .toUpperCase();

        const absent =
          row.dataset.status === "Absent";

        const isBoy =
          gender === "M" ||
          gender === "MALE" ||
          gender === "BOY";

        const isGirl =
          gender === "F" ||
          gender === "FEMALE" ||
          gender === "GIRL";

        if (isBoy) {
          if (absent) {
            actualBoysAbsent++;
          } else {
            actualBoysPresent++;
          }
        }

        if (isGirl) {
          if (absent) {
            actualGirlsAbsent++;
          } else {
            actualGirlsPresent++;
          }
        }
      });

      const validatedBoysPresent =
        parseInt(
          boysPresentInput.value,
          10
        ) || 0;

      const validatedBoysAbsent =
        parseInt(
          boysAbsentInput.value,
          10
        ) || 0;

      const validatedGirlsPresent =
        parseInt(
          girlsPresentInput.value,
          10
        ) || 0;

      const validatedGirlsAbsent =
        parseInt(
          girlsAbsentInput.value,
          10
        ) || 0;

      const syncErrors = [];

      if (
        actualBoysPresent !==
        validatedBoysPresent
      ) {
        syncErrors.push(
          `Boys present: marked ` +
          `${actualBoysPresent}, validated ` +
          `${validatedBoysPresent}`
        );
      }

      if (
        actualBoysAbsent !==
        validatedBoysAbsent
      ) {
        syncErrors.push(
          `Boys absent: marked ` +
          `${actualBoysAbsent}, validated ` +
          `${validatedBoysAbsent}`
        );
      }

      if (
        actualGirlsPresent !==
        validatedGirlsPresent
      ) {
        syncErrors.push(
          `Girls present: marked ` +
          `${actualGirlsPresent}, validated ` +
          `${validatedGirlsPresent}`
        );
      }

      if (
        actualGirlsAbsent !==
        validatedGirlsAbsent
      ) {
        syncErrors.push(
          `Girls absent: marked ` +
          `${actualGirlsAbsent}, validated ` +
          `${validatedGirlsAbsent}`
        );
      }

      if (syncErrors.length > 0) {
        messageBox.value =
          "⚠️ Marking does not match " +
          "validated totals:\n" +
          syncErrors.join("\n") +
          "\n\nPlease correct your marking " +
          "before submitting.";

        return;
      }

      // --------------------------------
      // Check selected learner reasons
      // --------------------------------
      const selectedRows =
        Array.from(
          learnerList.querySelectorAll(
            ".learner-row"
          )
        ).filter(row =>
          row.querySelector(
            ".learner-check"
          )?.checked
        );

      const missingReason =
        selectedRows.filter(row =>
          !row.querySelector(
            ".row-reason"
          ).value
        );

      if (missingReason.length > 0) {
        missingReason.forEach(row => {
          const checkbox =
            row.querySelector(
              ".learner-check"
            );

          checkbox.checked = false;

          row.dataset.status =
            "Present";

          row.dataset.reason =
            "N/A";

          syncRowHighlight(
            row,
            false
          );
        });

        const names =
          missingReason
            .map(row =>
              row.dataset.name
            )
            .join(", ");

        messageBox.value =
          "⚠️ No reason selected for: " +
          `${names}. These learners have been ` +
          "deselected. Please review and resubmit.";

        return;
      }

      const year =
        Number(selectedDateIso.slice(0, 4));

      const term =
        getTermFromDate(selectedDateIso);

      const learnersPayload =
        Array.from(
          learnerList.querySelectorAll(
            ".learner-row"
          )
        ).map(row => ({
          learnerId:
            row.dataset.id,

          name:
            row.dataset.name,

          gender:
            row.dataset.gender,

          classId:
            row.dataset.classId,

          schoolId:
            row.dataset.schoolId,

          dob:
            row.dataset.dob,

          classTeacher:
            row.dataset.classTeacher,

          status:
            row.dataset.status,

          reason:
            row.dataset.reason
        }));

      const role =
        (t.role || "teacher")
          .toLowerCase();

      const isAdmin =
        role !== "teacher";

      const selectedOpt =
        classSelect.selectedOptions[0];

      const submittingEmail =
        isAdmin
          ? (
              selectedOpt?.dataset
                ?.teacherEmail ||
              t.email
            )
          : t.email;

      const submittingId =
        isAdmin
          ? (
              selectedOpt?.dataset
                ?.teacherName ||
              t.teacherId
            )
          : t.teacherId;

      const payload = {
        year,
        term,

        // Existing backend format.
        date: attendanceDate,

        schoolId:
          t.schoolId,

        schoolName:
          t.schoolName || "",

        classId:
          currentClassId,

        teacher: {
          email:
            submittingEmail,

          teacherId:
            submittingId,

          role:
            t.role,

          schoolId:
            t.schoolId,

          classId:
            currentClassId
        },

        learners:
          learnersPayload
      };

      const functionUrl =
        "https://attendance-backend-e4cbgrcxc5czd3ez." +
        "southafricanorth-01.azurewebsites.net/api/attendance" +
        `?code=${encodeURIComponent(
          window.azure.attendanceKey
        )}`;

      spinner.style.display =
        "block";

      messageBox.style.display =
        "none";

      try {
        const res =
          await fetch(functionUrl, {
            method: "POST",
            headers: {
              "Content-Type":
                "application/json"
            },
            body:
              JSON.stringify(payload)
          });

        const text =
          await res.text();

        console.log(
          "Attendance response:",
          res.status,
          text
        );

        if (!res.ok) {
          throw new Error(
            `Attendance submission failed ` +
            `(${res.status}): ${text}`
          );
        }

        spinner.style.display =
          "none";

        submitBtn.disabled =
          true;

        submitBtn.textContent =
          "Submitted";

        submitBtn.style.backgroundColor =
          "#999";

        submitBtn.style.cursor =
          "not-allowed";

        const confirmationBox =
          document.createElement("div");

        confirmationBox.className =
          "confirmation-box";

        confirmationBox.style.border =
          "2px solid #217346";

        confirmationBox.style.padding =
          "20px";

        confirmationBox.style.background =
          "#f6fff6";

        confirmationBox.style.borderRadius =
          "6px";

        confirmationBox.style.textAlign =
          "center";

        confirmationBox.style.marginTop =
          "20px";

        confirmationBox.innerHTML = `
          <img
            src="https://cdn.shopify.com/s/files/1/0667/3081/9783/files/New_main_LogoTMDraft.png?v=1775623509"
            alt="iForm365"
            style="height:50px; margin-bottom:12px;"
          >

          <p style="
            color:#217346;
            font-size:18px;
            margin:0 0 8px 0;
          ">
            ✅ Attendance submitted successfully!
          </p>

          <p style="
            color:#555;
            font-size:15px;
            margin:0 0 8px 0;
          ">
            Your attendance record has been saved.
          </p>

          <p style="
            color:#888;
            font-size:14px;
            margin:0;
          ">
            Cara powered by
            <strong>iForm365</strong>
          </p>
        `;

        if (attendanceWrapper) {
          attendanceWrapper.appendChild(
            confirmationBox
          );
        }

        setTimeout(async () => {
          confirmationBox.remove();

          learnerList.innerHTML =
            "";

          boysPresentInput.value =
            "";

          boysAbsentInput.value =
            "";

          girlsPresentInput.value =
            "";

          girlsAbsentInput.value =
            "";

          dateInput.value =
            "";

          messageBox.style.display =
            "block";

          learnersData =
            [];

          currentClassId =
            null;

          resetSubmitState();

          if (isAdmin) {
            messageBox.value =
              "Select next class to submit attendance.";

            await loadAdminTeachers();
          } else {
            currentClassId =
              (t.classId || "").trim();

            messageBox.value =
              `Reloading class ${currentClassId}…`;

            // A new date must be selected before
            // reloading the class.
          }
        }, 3000);

      } catch (err) {
        console.error(
          "Attendance submission failed:",
          err
        );

        spinner.style.display =
          "none";

        messageBox.style.display =
          "block";

        messageBox.value =
          "Error submitting attendance: " +
          (err.message || err);
      }
    }
  );

  // ================================
  // INITIALISE
  // ================================
  initRoleAndClassUI();

  await loadValidDates();

  await loadData();

});
